export default __webpack_public_path__ + "static/image9-ea25b8e856390723513e7c43623a5523.webp";